<template>
  <div
    @mouseenter="$store.state._overlays.categoriesOverlay = true"
    @mouseleave="$store.state._overlays.categoriesOverlay = false"
    class="header-dropdown"
    :class="{ 'header-dropdown--visible': $store.state._overlays.categoriesOverlay }"
    v-if="activeId === -1"
  >
    <div class="header-dropdown__container container">
      <div v-if="category" class="header-dropdown__category">
        <router-link
          :to="{ name: 'catalog', params: { id: category.id } }"
          v-if="category.head_img"
          class="header-dropdown__category-img"
        >
          <ImgComponent :head_img="category.head_img" width="300" height="400" />
        </router-link>
        <ul class="header-dropdown__category-childs">
          <li v-for="(child, i) in category.childs" :key="i">
            <router-link :to="{ name: 'catalog', params: { id: child.id } }">{{ child.title }}</router-link>
          </li>
        </ul>
      </div>
      <div v-else-if="activeId === -1" class="all-brands">
        <BrandsAlphabetComponent />
      </div>
      <!--      <div class="header-dropdown__brands">-->
      <!--        <span class="header-dropdown__brands-title">Популярные бренды:</span>-->
      <!--        <div class="header-dropdown__brands-list">-->
      <!--          <BrandComponent v-for="(brand, i) in popular_brands" :key="i" :data="brand" />-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import BrandComponent from "components/brands/BrandComponent.vue";
import BrandsAlphabetComponent from "components/brands/BrandsAlphabetComponent.vue";

export default {
  name: "HeaderSearchComponent",
  props: {
    activeId: Number,
  },
  data() {
    return {
      search: undefined,
    };
  },
  computed: {
    category() {
      return this.$store.state.categories && this.$store.state.categories.length
        ? this.$store.state.categories.find((category) => category.id === this.activeId)
        : {};
    },
    popular_brands() {
      return this.$store.state.popular_brands ? this.$store.state.popular_brands.slice(0, 8) : [];
    },
  },
  components: { BrandsAlphabetComponent, BrandComponent },
};
</script>

<style lang="stylus">
.header-dropdown {
  background var(--white)
  position: absolute;
  left 0
  right 0
  top 100%
  visibility hidden
  opacity: 0;
  transition var(--transition)
	pointer-events: none

  &--visible {
    visibility visible
    opacity 1
		pointer-events: auto
  }

  &__container {
    display flex
    flex-direction column
    gap 20px
		padding 20px
  }

  &__category {
    display flex
    align-items flex-start
    gap 30px
    width 100%

    &-img {
      width 154px
      height 182px
      flex-shrink 0
      border: 1px solid var(--gray-2-dark)
      border-radius: var(--big_radius)
      padding 5px

      &:hover {
        border-color var(--main-color)
      }

      img {
        width 100%
        height 100%
        object-fit contain
      }
    }

    &-childs {
      font-size: 0.875em
      line-height: 180%;
      display flex
      flex-wrap wrap
      flex-direction column
      align-items flex-start
      width 100%
      max-height 260px

      li {
        margin-bottom: 3px;
        margin-right 10px

        a {
          display flex
          color var(--dark)
        }
      }
    }
  }

  &__brands {
    display flex
    flex-direction column
    gap 20px

    &-title {
      font-weight 700
      font-size: 0.875em
      line-height: 145%;
      color var(--main-color)
    }

    &-list {
      display grid
      grid-template-columns repeat(8, 1fr)
      gap 18px
    }
  }
}
</style>
